var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgArrRight = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6757 4.77535C11.9101 4.54103 12.29 4.54103 12.5243 4.77535L17.3243 9.57535C17.5586 9.80966 17.5586 10.1896 17.3243 10.4239L12.5243 15.2239C12.29 15.4582 11.9101 15.4582 11.6757 15.2239C11.4414 14.9896 11.4414 14.6097 11.6757 14.3753L15.4515 10.5996H4.1C3.76863 10.5996 3.5 10.331 3.5 9.99961C3.5 9.66824 3.76863 9.39961 4.1 9.39961H15.4515L11.6757 5.62387C11.4414 5.38956 11.4414 5.00966 11.6757 4.77535Z",
    fill: "#868381"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgArrRight, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ArrRight.9f73beba.svg";
export { ForwardRef as ReactComponent };